export default __webpack_public_path__ + "./fonts/error.9914815d.svg";